<template>
  <div class="pageContent parking">
    <LoadingModal />
    <div v-if="!$store.state.pageLoading">
      <Top :title="name" :message="tips" v-if="tips != ''" />
      <VTitle val="请选择面值" :showLine="false" />
      <TypeList
        :status="radio"
        :list="selList"
        :activeIndex="selItem"
        @selItem="handleSel"
        :isMember="isMember"
        :canSel="canSel"
        :vip_discount="vip_discount"
      />
      <VTitle val="充值账号" :showLine="false" />
      <div class="pageBigRadius pageCarServeShadow">
        <van-field
          v-model="account"
          class="pageBigRadius input"
          placeholder="请输入手机号码"
          :error-message="phoneErrorMsg"
          maxlength="11"
          @input="input"
          type="number"
          ref="accounts"
          id="accounts"
        />
      </div>
      <VTitle val="支付方式" :showLine="false" />
      <PayWay
        ref="payway"
        :sellData="sellData"
        :tips="tips"
        :discount="discount"
        :isWechatPay="wechatpay"
        :type="8"
        :params="params"
        :isSend="isSend"
        :balance="balance"
        :couponsId="couponsId"
        :couponsName="couponsName"
        :isMember="isMember"
        :vip_discount="vip_discount"
        :discount_coupons="discount_coupons"
        :can_use_power="can_use_power"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        @onComfirm="payHandle"
      />
      <!-- <Tips :content="describe">
        <div slot="content">
          <ul
            style="
              list-style: disc;
              color: #000;
              opacity: 0.53;
              margin-left: 15px;
            "
          >
            <li style="list-style: disc">
              <b>兑换流程：</b>
              <p>
                打开天猫养车APP→手机登录后，首页进入“我的”→选择“权益兑换”→输入兑换码完成兑换→在“我的套餐卡”查看。
              </p>
              <b>使用流程：</b>
              <p>
                打开天猫养车APP→手机登录后，首页进入“我的”→在“我的套餐卡”查看，点击对应服务→预约→选址门店和时间到店服务
              </p>
            </li>
          </ul>
        </div>
      </Tips> -->
    </div>
  </div>
</template>

<script>
import { getProductList } from "api/onLine";
import { couponExchange } from "api/offLine";

export default {
  props: {
    type: String,
    name: String,
    cid: Number,
    balance: Number,
    couponsId: String,
    couponsName: String,
    couponsDeduct: Number,
    isMember: Boolean,
    ident: String,
    mouldId: String,
    couponsBalanceList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      appimg: require("assets/sy.png"),
      radio: 0,
      area: "",
      // 数据列表
      selList: [
        {
          productCustomerPrice: "5.000",
          productDenomination: "5.000",
          productFlowVal: "",
          productId: "a01",
          productIsAnyDeno: 0,
          productName: "5元停车券",
          productNo: "10",
          productPrimePrice: "5.000",
          productStatus: 1,
          productStock: 50,
        },
        {
          productCustomerPrice: "10.000",
          productDenomination: "10.000",
          productFlowVal: "",
          productId: "a02",
          productIsAnyDeno: 0,
          productName: "10元停车券",
          productNo: "11",
          productPrimePrice: "10.000",
          productStatus: 1,
          productStock: 30,
        },
        {
          productCustomerPrice: "15.000",
          productDenomination: "15.000",
          productFlowVal: "",
          productId: "a03",
          productIsAnyDeno: 0,
          productName: "15元停车券",
          productNo: "12",
          productPrimePrice: "15.000",
          productStatus: 1,
          productStock: 10,
        },
      ],
      selItem: null,
      canSel: false, // 整个列表是否可选
      selListDefaultData: [],
      // 支付数据
      sellData: { sell_price: -1 },
      tips: "",
      describe: "",
      discount: 0,
      index: 0,
      wechatpay: false,
      account: "",
      params: { productId: "" },
      sms: "",
      isSend: true,
      data: {},
      vip_discount: 0,
      discount_coupons: [],
      can_use_power: false,
      phoneErrorMsg: "",
      isValid: false,
    };
  },
  created() {
    this.$store.commit("setPageLoading", false);
  },
  mounted() {
    this.loadData();
  },
  methods: {
    resetData() {
      this.selList = this.selListDefaultData.list;
      this.canSel = false;
      this.selItem = null;
      this.sellData = { sell_price: -1 };
    },
    loadData() {
      this.canSel = true;
      // getProductList(this.ident, this.mouldId).then((res) => {
      //   this.$clear();
      //   if (res.status == 200) {
      //     if (typeof res.data == "object") {
      //       this.selList = res.data;
      //       this.canSel = true;
      //     }
      //   } else {
      //     this.resetData();
      //     this.$error(res.message);
      //   }
      //   this.$nextTick(() => {
      //     this.$store.commit("setPageLoading", false);
      //     this.$clear();
      //   });
      // });
    },
    input(value) {
      if (!this.$regPhone(value)) {
        this.phoneErrorMsg = "手机号格式错误";
        this.isValid = false;
      } else {
        this.phoneErrorMsg = "";
        this.isValid = true;
      }
      this.params.account = this.account;
    },
    handleSel(i) {
      this.selItem = i;
      this.sellData = {
        ...this.selList[i],
        sell_price: Number(this.selList[i].productCustomerPrice),
      };
      this.params.productId = this.selList[i].productId;
    },
    payHandle(data) {
      this.$loading("支付中");
      let params = {
        productId: this.params.productId,
        couponIds: data.couponIds,
      };
      couponExchange(params).then((res) => {
        if (res.status == 200) {
          this.$successSync("购买成功", () => {});
        } else {
          this.$error(res.message);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.parking {
  /deep/ .van-field__control {
    color: #ff3300;
    font-size: 20px;
    font-weight: 900;
  }
}
</style>
